import BlurredBackgroundImage, {
  BlurredBackgroundImageProps,
} from './BlurredBackgroundImage';

export default BlurredBackgroundImage;
export type { BlurredBackgroundImageProps };
